const closeRexMenus = (except) => {
  document.querySelectorAll('details.rex-mobile-nav[open], details.rex-header-search[open]').forEach((details) => {
    if (details !== except) details.removeAttribute('open');
  });
};

document.addEventListener('click', (event) => {
  const menu = event.target.closest('details.rex-mobile-nav, details.rex-header-search');
  if (!menu) closeRexMenus();
  if (event.target.closest('.rex-mobile-nav__panel a')) closeRexMenus();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeRexMenus();
});

const reveal = () => {
  const nodes = document.querySelectorAll('.rex-reveal:not(.rex-visible)');
  if (!('IntersectionObserver' in window)) {
    nodes.forEach((node) => node.classList.add('rex-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('rex-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  nodes.forEach((node) => observer.observe(node));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
} else {
  reveal();
}

document.addEventListener('shopify:section:load', reveal);

const money = (cents) => {
  const currency = window.Shopify?.currency?.active || 'USD';
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents) / 100);
  } catch (error) {
    return `$${(Number(cents) / 100).toFixed(2)}`;
  }
};

const initProduct = (root) => {
  if (!root || root.dataset.rexReady === 'true') return;
  root.dataset.rexReady = 'true';

  const mainImage = root.querySelector('[id^="RexProductImage-"]');
  const stage = root.querySelector('.rex-native-product__stage');
  const thumbs = [...root.querySelectorAll('[data-rex-media]')];
  thumbs.forEach((thumb) => thumb.addEventListener('click', () => {
    if (!mainImage) return;
    mainImage.classList.add('is-changing');
    mainImage.src = thumb.dataset.src;
    mainImage.removeAttribute('srcset');
    mainImage.alt = thumb.dataset.alt || '';
    thumbs.forEach((item) => {
      const active = item === thumb;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    stage?.classList.remove('is-zoomed');
    requestAnimationFrame(() => mainImage.classList.remove('is-changing'));
  }));

  root.querySelector('[data-rex-zoom]')?.addEventListener('click', () => stage?.classList.toggle('is-zoomed'));

  const variantsNode = root.querySelector('[data-rex-variants]');
  if (!variantsNode) return;
  let variants = [];
  try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }
  const optionGroups = [...root.querySelectorAll('[data-option-position]')];
  const input = root.querySelector('[data-rex-variant-id]');
  const price = root.querySelector('[data-rex-price]');
  const submit = root.querySelector('.rex-native-product__add');
  const submitText = submit?.querySelector('span');

  const updateVariant = () => {
    const values = optionGroups.map((group) => group.querySelector('input:checked')?.value);
    const variant = variants.find((item) => item.options.every((option, index) => option === values[index]));
    if (!variant || !input || !submit) {
      if (submit) {
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        if (submitText) submitText.textContent = 'UNAVAILABLE';
      }
      return;
    }
    input.value = variant.id;
    submit.disabled = !variant.available;
    submit.setAttribute('aria-disabled', String(!variant.available));
    if (submitText) submitText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    if (price) {
      const current = price.querySelector('span');
      const compare = price.querySelector('s');
      const badge = price.querySelector('em');
      if (current) current.textContent = money(variant.price);
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
      }
      if (badge) badge.hidden = !(variant.compare_at_price > variant.price);
    }
    if (variant.featured_image?.src && mainImage) {
      mainImage.src = variant.featured_image.src;
      mainImage.removeAttribute('srcset');
    }
    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', nextUrl);
  };

  optionGroups.forEach((group) => group.addEventListener('change', updateVariant));
};

const initRexUI = (scope = document) => {
  scope.querySelectorAll('[data-rex-product]').forEach(initProduct);
  scope.querySelectorAll('[data-rex-sort]').forEach((select) => {
    if (select.dataset.rexReady === 'true') return;
    select.dataset.rexReady = 'true';
    select.addEventListener('change', () => select.form?.requestSubmit());
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initRexUI(), { once: true });
} else {
  initRexUI();
}

document.addEventListener('shopify:section:load', (event) => initRexUI(event.target));
